import { api_pyth, api_pyth_ssr } from './utils';

export async function fetchPythData(query: string, ssr = false, fetch?: any) {
	if (ssr) {
		const response = await api_pyth_ssr(fetch, 'get', 'latest_price_feeds?' + query);
		if (response.status === 200) {
			const data = await response.json();
			return data;
		}
	} else {
		const response = await api_pyth('get', 'latest_price_feeds?' + query);
		if (response.status === 200) {
			const data = await response.json();
			return data;
		}
	}
}
